import { render, staticRenderFns } from "./AdvertSlotTabs.vue?vue&type=template&id=72acd3d0&scoped=true"
import script from "./AdvertSlotTabs.vue?vue&type=script&lang=js"
export * from "./AdvertSlotTabs.vue?vue&type=script&lang=js"
import style0 from "./AdvertSlotTabs.vue?vue&type=style&index=0&id=72acd3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72acd3d0",
  null
  
)

export default component.exports